import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Timestamp({data}) {
    return (
        <div className="time_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="m-auto">
                        <h5 className="episode_name text-start">
                            Timestamps
                        </h5>
                        <ul className="timestamp">
                            <li><span>00:11</span> Guest Introduction</li>
                            <li><span>01:30</span> The journey of becoming a business coach.</li>
                            <li><span>06:00</span> The importance of Kindness in scaling a business</li>
                            <li><span>06:00</span> Leaders as introverts and extroverts.</li>
                            <li><span>08:25</span> Finding the right partner and people to work with.</li>
                            <li><span>09:28</span> The 5 Ps methodology for making business decisions.</li>
                            <li><span>22:56</span> The core things to remember when pitching your business to an investor.</li>
                            <ul className="sub__list">
                                <li> - Understanding equity and valuation as a startup.</li>
                                <li> - What investors are thinking during investor meetings?</li>
                                <li> - Are NDAs important during investor meetings?</li>
                                <li >- How to pick which investors to pitch your business idea to?</li>
                            </ul>
                            <li><span>37:23</span> What changes are needed to transition from being a startup or a small business to an enterprise company?</li>
                            <ul className="sub__list">
                                <li> - How to lower your business cost and maximize profits?</li>
                                <li> - How do you scale your vision or message to your team without diluting it?</li>
                                <li> - How is making more money tied to growing talent as a business?</li>
                            </ul>
                            <li><span>50:41</span> What is the one thing you think business owners should personally execute instead of hiring people to do so?</li>
                            <li><span>54:09</span> How can technology help brick and mortar businesses circumvent the negative impacts of the on-going pandemic?</li>
                            <ul className="sub__list">
                                <li>- The tech that will change the future.</li>
                            </ul>
                            <li><span>1:04:50</span> The one tip that entrepreneurs need to succeed.</li>
                            <ul className="sub__list">
                                <li> - Revisiting your business model and problem statement.</li>
                                <li> - How to grow company culture and profits through flexibility.</li>
                                <li> - The importance of introspection for businesses.</li>
                            </ul>
                        </ul>
                    </Col>
                </Row>

            </Container>
        </div>
    );
}

export default Timestamp;